const ACCEPTED_TYPES = ["image/jpeg", "image/png", "image/webp"];

export const CERT_ACCEPT = ACCEPTED_TYPES.join(",");
export const CERT_MAX_SIDE = 2048;

// Only formats the parents' app can render as an image: the server stores
// any upload as-is, so HEIC or PDF would show up as an empty certificate.
export function isAcceptedCertType(type: string): boolean {
  return ACCEPTED_TYPES.includes(type);
}

export function fitWithin(
  width: number,
  height: number,
  max: number
): { width: number; height: number } {
  const scale = Math.min(1, max / Math.max(width, height));
  return { width: Math.round(width * scale), height: Math.round(height * scale) };
}

// Mirrors the mobile app (ImagePicker maxWidth 2048, quality 85): keeps the
// upload small for the proxy body limit and always produces a JPEG.
export async function compressCertPhoto(file: File): Promise<File> {
  const bitmap = await createImageBitmap(file);
  const { width, height } = fitWithin(bitmap.width, bitmap.height, CERT_MAX_SIDE);
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Не удалось подготовить фото");
  // JPEG has no alpha: transparent PNG pixels would otherwise turn black.
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(bitmap, 0, 0, width, height);
  bitmap.close();
  const blob = await new Promise<Blob | null>((resolve) =>
    canvas.toBlob(resolve, "image/jpeg", 0.85)
  );
  if (!blob) throw new Error("Не удалось сжать фото");
  const base = file.name.replace(/\.[^.]+$/, "") || "medical_cert";
  return new File([blob], `${base}.jpg`, { type: "image/jpeg" });
}
